import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ModelService } from "../Services/model.service";
import { ValidFeature } from "../Model/ValidFeature";
import { ValidFeatureValue } from "../Model/ValidFeatureValue";
import { TranslateService } from "@ngx-translate/core";
import { Message } from "../Model/System/Message";
import { StartAction } from "../Model/Dto/StartAction";
import { ValueChangedEvent } from "devextreme/ui/select_box";
import { ValidFeatureService } from "../Services/validFeature.service";
import { RowUpdatedEvent } from "devextreme/ui/data_grid";
import { LoginService } from "../Services/login.service";


@Component({
  selector: "validFeature",
  templateUrl: "validFeature.component.html",
  styleUrl: './validFeature.component.css'
})
export class ValidFeatureComponent {
  @Input() ValidFeatures: ValidFeature[];
  @Output() ValidFeaturesChange = new EventEmitter<ValidFeature[]>();

  validFeatureValues: ValidFeatureValue[] = [];
  types: string[] = ["String", "Boolean", "Number", "Double"];

  public determineFeatureTypesDialogVisible: boolean = false;
  overwriteFeatureTypes: boolean = false;

  constructor(public modelService: ModelService, public translate: TranslateService, public validFeatureService: ValidFeatureService, public loginService: LoginService) {

  }

  async updateValidFeatureValue(event: RowUpdatedEvent) {
    await this.validFeatureService.updateValidFeature(event.data, this.loginService.currentCustomer.id);
    this.ValidFeaturesChange.emit(this.ValidFeatures);
  }

  startDetermineValueTypeJob() {
    const startAction = new StartAction();
    startAction.customerId = this.modelService.loginService.currentUser.customerId;

    startAction.actionType = "DetermineFeatureTypes";
    startAction.actionId = "DetermineFeatureTypes";
    startAction.actionParameter = this.createParameterStringAsJsonString();
    this.hideDetermineFeatureTypesDialog();
    this.modelService.jobService.startJob(startAction)
      .subscribe(success => {
        if (success) {
          this.modelService.systemService.notify(new Message(this.translate.instant("Das Makro wurde gestartet")));
        }
      });
  }

  onGridToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      locateInMenu: 'auto',
      template: 'determineValueTypeButtonTemplate'
    });
  }

  
  createParameterStringAsJsonString() {
    return (0 != this.ValidFeatures.length)
      ? JSON.stringify({
        Id: this.ValidFeatures[0].validFeatureSystemId,
        OverwriteFeatureTypes: this.overwriteFeatureTypes
        })
      :
        JSON.stringify({
          Id: ""
        });
  }

  showDetermineFeatureTypesDialog() {
    this.overwriteFeatureTypes = false;
    this.determineFeatureTypesDialogVisible = true;
  }

  hideDetermineFeatureTypesDialog() {
    this.determineFeatureTypesDialogVisible = false;
  }
}
